import { Clock, MapPin, Sprout, CloudRain, CalendarClock, MessageSquare } from 'lucide-react';

const timeOf = (t) => new Date(t).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

const rainText = (job) => {
  const first = (job.customer_name || '').trim().split(' ')[0];
  const body = `Hi${first ? ` ${first}` : ''}, this is Walker Lawn Care. Because of the rain today we need to push your lawn service back. See you tomorrow! Reply with any questions.`;
  return `sms:${(job.customer_phone || '').replace(/[^\d+]/g, '')}?&body=${encodeURIComponent(body)}`;
};

const RainAlert = ({ rain }) => (
  <div data-testid="rain-day-alert" className="mx-3 mt-3 flex items-start gap-3 rounded-xl bg-sky-50 border border-sky-200 px-4 py-3">
    <CloudRain className="h-5 w-5 text-sky-600 shrink-0 mt-0.5" />
    <div>
      <p className="font-semibold text-sky-900 text-sm">Rain likely today ({rain}% chance)</p>
      <p className="text-xs text-sky-800">Consider rescheduling outdoor jobs. Tap Text to let the customer know, or Reschedule to pick a new day.</p>
    </div>
  </div>
);

export const TodaysJobs = ({ jobs, employees, onOpen, rain, rainLikely }) => {
  const nameOf = (id) => employees.find((e) => e.id === id)?.name;
  return (
    <div data-testid="todays-jobs-card" className="bg-white rounded-2xl shadow-sm border border-lime-100 h-full">
      <div className="px-5 py-4 border-b border-lime-100 flex items-center justify-between">
        <p className="font-semibold text-stone-900 text-lg" style={{ fontFamily: "'Outfit', sans-serif" }}>Today's Jobs</p>
        <span className="text-xs font-semibold bg-lime-100 text-green-800 px-2.5 py-1 rounded-full" data-testid="todays-jobs-count">{jobs.length}</span>
      </div>
      {rainLikely && jobs.length > 0 && <RainAlert rain={rain} />}
      {jobs.length === 0 ? (
        <div className="py-12 text-center text-stone-500" data-testid="todays-jobs-empty">
          <Sprout className="h-12 w-12 mx-auto mb-3 text-lime-400" />
          <p className="font-medium">No jobs scheduled today</p>
          <p className="text-sm">Enjoy the break or book a new appointment.</p>
        </div>
      ) : (
        <ol className="p-3 space-y-2">
          {jobs.map((job, i) => {
            const crew = (job.assigned_employees || []).map(nameOf).filter(Boolean);
            return (
              <li key={job.id} className="flex flex-col sm:flex-row sm:items-center sm:gap-2 rounded-xl hover:bg-lime-50 transition-colors">
                <button
                  type="button"
                  onClick={() => onOpen(job)}
                  data-testid={`todays-job-${job.id}`}
                  className="flex-1 min-w-0 flex items-start gap-3 p-3 text-left"
                >
                  <span className="h-8 w-8 shrink-0 rounded-full bg-green-600 text-white text-sm font-bold flex items-center justify-center">{i + 1}</span>
                  <span className="flex-1 min-w-0">
                    <span className="block font-semibold text-stone-900 truncate">{job.customer_name}</span>
                    <span className="flex items-center gap-1 text-xs text-stone-500 truncate"><MapPin className="h-3 w-3 shrink-0" />{job.customer_address || 'No address'}</span>
                    {crew.length > 0 && <span className="block text-xs text-green-700 mt-0.5">{crew.join(', ')}</span>}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-medium text-stone-600 shrink-0"><Clock className="h-3 w-3" />{timeOf(job.start_time)}</span>
                </button>
                {rainLikely && (
                  <span className="pl-14 pr-3 pb-3 sm:p-0 sm:mr-3 shrink-0 flex gap-1.5">
                    {job.customer_phone && (
                      <a
                        href={rainText(job)}
                        data-testid={`rain-text-job-${job.id}`}
                        className="flex items-center justify-center gap-1 rounded-lg bg-green-600 hover:bg-green-700 text-white text-xs font-semibold px-3 py-2 transition-colors"
                      >
                        <MessageSquare className="h-3.5 w-3.5" />
                        Text
                      </a>
                    )}
                    <button
                      type="button"
                      onClick={() => onOpen(job)}
                      data-testid={`reschedule-job-${job.id}`}
                      className="flex items-center justify-center gap-1 rounded-lg bg-sky-600 hover:bg-sky-700 text-white text-xs font-semibold px-3 py-2 transition-colors"
                    >
                      <CalendarClock className="h-3.5 w-3.5" />
                      Reschedule
                    </button>
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};
